/**
 * Half-Sizer upsell "Add" handler.
 *
 * Uses a single delegated listener on `document` so it survives cart-drawer
 * re-renders (the drawer replaces `.f-cart-drawer__items` innerHTML on every
 * cart change). Reads the variant id from `.f-half-sizer__add[data-variant-id]`,
 * adds it, then emits the theme's cartUpdate event so the drawer refreshes.
 */
(function () {
  if (window.__halfSizerBound) return;
  window.__halfSizerBound = true;

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".f-half-sizer__add");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains("is-loading")) return;

    btn.classList.add("is-loading", "btn--loading");

    const cartDrawer = document.querySelector("cart-drawer");
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
      formData.append(
        "sections",
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
    }

    fetch(FoxThemeSettings.routes.cart_add_url, {
      method: "POST",
      headers: {
        Accept: "application/javascript",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error("Half-Sizer add failed:", response.description);
          return;
        }
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);
      })
      .catch((error) => console.error(error))
      .finally(() => btn.classList.remove("is-loading", "btn--loading"));
  });
})();
